module.exports = __webpack_public_path__ + "img/goodthings25_oztix_600x300.b805d66e.jpg";